import script from "./PositionMapView.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionMapView.vue?vue&type=script&setup=true&lang=js"

import "./PositionMapView.vue?vue&type=style&index=0&id=589ebd87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589ebd87"]])

export default __exports__